import React from "react";
import Form from "react-bootstrap/Form";
import FormControl from "react-bootstrap/FormControl";

const SearchBox = ({ searchChange }) => {
  const onChange = (value) => {
    console.log(value);
    if (value.length > 2    ) {
      searchChange(value);
    }
  };
  return (
    <Form inline>
      <FormControl
        type="text"
        placeholder="Search"
        className="mr-sm-2"
        onChange={(e) => onChange(e.target.value)}
      />
    </Form>
  );
};

export default SearchBox;
